export default function SkipToContent() {
  const skipToMain = () => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#main-content"
      onClick={(e) => {
        e.preventDefault();
        skipToMain();
      }}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] bg-[#1a4d2e] text-white px-6 py-3 rounded-md font-medium focus:outline-none focus:ring-4 focus:ring-[#1a4d2e] focus:ring-opacity-50"
      aria-label="Skip to main content"
    >
      Skip to main content
    </a>
  );
}
